import HomePage from './views/HomePage.vue';

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/home'
  // },
  {
    path: '/home',
    name: 'home',
    component: HomePage,
    meta: {
      title: 'Accueil',
      requiresAuth: false // TEMPORARILY DISABLED FOR TESTING
    }
  }
];

export default routes;
